import React from "react";
import Welcome from "../../components/Welcome";

export default function Home() {
  return <Welcome />;
}
